import React, { useState, useRef, useEffect, useCallback } from "react";
import { Rnd } from "react-rnd";
import MemecoinPageDirectionsModal from "../components/MemecoinPageDirectionsModal";
import "./MemecoinPage.css";

const fish = [{ id: 1, src: "feesh-transparent.png" }];
const lips = [
  { id: 1, src: "mouth1.png" },
  { id: 2, src: "mouth2.png" },
  { id: 3, src: "mouth3.png" },
  { id: 4, src: "mouth4.png" },
  { id: 5, src: "mouth5.png" },
  { id: 6, src: "mouth6.png" },
];

function VideoBackground() {
  const videos = ["background1.mp4", "background2.mp4"];
  const random = Math.floor(Math.random() * videos.length);
  const selectedVideo = videos[random];
  return (
    <video autoPlay loop muted id="video-background">
      <source src={selectedVideo} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
}

function App() {
  const [selectedImages, setSelectedImages] = useState([]);
  const [mainImage, setMainImage] = useState(null);
  const [activeImage, setActiveImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const mainImageRef = useRef(null);

  const deleteActive = useCallback(
    (event) => {
      if (
        (event.key === "Delete" || event.key === "Backspace") &&
        activeImage !== null
      ) {
        setSelectedImages((prevImages) =>
          prevImages.filter((image) => image.key !== activeImage)
        );
        setActiveImage(null);
      }
    },
    [activeImage]
  );

  useEffect(() => {
    document.addEventListener("keydown", deleteActive);

    return () => {
      document.removeEventListener("keydown", deleteActive);
    };
  }, [deleteActive]);

  const handleImageClick = (image) => {
    const newImage = {
      ...image,
      key: Date.now(),
    };
    setSelectedImages([...selectedImages, newImage]);
  };

  const clearSelectedImages = () => {
    setSelectedImages([]);
    setActiveImage(null);
  };

  const handleMainImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setMainImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleContainerClick = (e) => {
    if (
      e.target.className === "main-image" ||
      e.target.className === "background-image"
    ) {
      setActiveImage(null);
    }
  };

  return (
    <div className="App">
      <VideoBackground />
      <div className="content">
        <h1>feesh maker</h1>
        <a target="_blank" rel="noreferrer" href="https://feesh.fun">
          back to feesh
        </a>
        <div className="image-upload">
          <h3>background image</h3>
          <input
            type="file"
            accept="image/*"
            onChange={handleMainImageUpload}
          />
        </div>
        <button onClick={clearSelectedImages} className="clear-button">
          Clear
        </button>
        <button
          onClick={() => setIsModalOpen(true)}
          className="directions-button"
        >
          Need help?
        </button>
        <div className="image-list-container">
          <h3>add feesh:</h3>
          <div className="image-list">
            {fish.map((image) => (
              <div className="thumbnail-container" key={image.id}>
                <img
                  src={image.src}
                  alt={image.name}
                  onClick={() => handleImageClick(image)}
                  className="thumbnail"
                />
              </div>
            ))}
          </div>
        </div>
        <div className="image-list-container">
          <h3>add big lips:</h3>
          <div className="image-list">
            {lips.map((image) => (
              <div className="thumbnail-container" key={image.id}>
                <img
                  src={image.src}
                  alt={image.name}
                  onClick={() => handleImageClick(image)}
                  className="thumbnail"
                />
              </div>
            ))}
          </div>
        </div>
        <div
          className="main-image"
          onClick={handleContainerClick}
          ref={mainImageRef}
        >
          {mainImage && (
            <img src={mainImage} alt="Main" className="background-image" />
          )}
          {selectedImages.map((image) => (
            <Rnd
              key={image.key}
              default={{
                x: 0,
                y: 0,
                width: 100,
                height: 100,
              }}
              lockAspectRatio={true}
              style={{
                border: activeImage === image.key ? "2px solid #00f" : "none",
                padding: activeImage === image.key ? "5px" : "0",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setActiveImage(image.key);
              }}
            >
              <img
                src={image.src}
                alt={image.name}
                style={{ width: "100%", height: "100%" }}
              />
            </Rnd>
          ))}
        </div>
      </div>
      <MemecoinPageDirectionsModal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
      />
    </div>
  );
}

export default App;
